import { render, staticRenderFns } from "./iframe3.vue?vue&type=template&id=5d438fbb&scoped=true&"
import script from "./iframe3.vue?vue&type=script&lang=js&"
export * from "./iframe3.vue?vue&type=script&lang=js&"
import style0 from "./iframe3.vue?vue&type=style&index=0&id=5d438fbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d438fbb",
  null
  
)

export default component.exports